import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cli-landing-header',
  templateUrl: './landing-header.component.html',
  styleUrls: ['./landing-header.component.scss']
})
export class LandingHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
